module.exports = __webpack_public_path__ + "static/media/ToT-bottom.cbe98e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/ToT-bottom.png
// module id = 1430
// module chunks = 0